export const ERROR_MESSAGE_REQUIRED = 'wajib diisi ya';
export const ERROR_MESSAGE_NAME_DUPLICATE = 'namanya jangan sama ya';
export const ERROR_MESSAGE_MIN_RP_0 = 'minimal Rp0';
export const ERROR_MESSAGE_MIN_RP_1 = 'minimal Rp1';
export const ERROR_MESSAGE_MAX_PERCENTAGE_TAX = 'Maksimal 100%';
